import React from 'react';
import { DiffPayload } from './types';
interface Props {
  diff: DiffPayload;
}
export function RecordDiff({
  diff
}: Props) {
  if (diff.kind === 'fields') return <FieldDiff changes={diff.changes} data-id="element-1967" />;
  return <ProseDiff before={diff.before} after={diff.after} data-id="element-1968" />;
}
function FieldDiff({
  changes
}: {
  changes: {
    label: string;
    before: string;
    after: string;
  }[];
}) {
  return <div className="bg-[#0d1117] rounded-[12px] overflow-hidden border border-white/[0.06]" data-id="element-1969">
      <div className="grid grid-cols-2 text-[11px] uppercase tracking-wider text-[#8a8680]/60 bg-[#161b22] border-b border-white/[0.06]" data-id="element-1970">
        <div className="px-4 py-2" data-id="element-1971">Before</div>
        <div className="px-4 py-2 border-l border-white/[0.06]" data-id="element-1972">After</div>
      </div>
      {changes.map((c, i) => <div key={i} className="grid grid-cols-2 text-[13px] border-b border-white/[0.04] last:border-b-0" data-id="element-1973">
          <div className="px-4 py-3 bg-[#2d1215]/40" data-id="element-1974">
            <div className="text-[11px] text-[#8a8680]/60 mb-1" data-id="element-1975">{c.label}</div>
            <div className="text-[#f47067]" data-id="element-1976">{c.before}</div>
          </div>
          <div className="px-4 py-3 bg-[#12261e]/40 border-l border-white/[0.06]" data-id="element-1977">
            <div className="text-[11px] text-[#8a8680]/60 mb-1" data-id="element-1978">{c.label}</div>
            <div className="text-[#7ee787]" data-id="element-1979">{c.after}</div>
          </div>
        </div>)}
    </div>;
}
function ProseDiff({
  before,
  after
}: {
  before: string;
  after: string;
}) {
  const beforeLines = before.split('\n');
  const afterLines = after.split('\n');
  return <div className="bg-[#0d1117] rounded-[12px] overflow-hidden border border-white/[0.06] font-mono text-[12px] leading-relaxed" data-id="element-1980">
      <div className="grid grid-cols-2 text-[11px] uppercase tracking-wider text-[#8a8680]/60 bg-[#161b22] border-b border-white/[0.06]" data-id="element-1981">
        <div className="px-4 py-2" data-id="element-1982">Before</div>
        <div className="px-4 py-2 border-l border-white/[0.06]" data-id="element-1983">After</div>
      </div>
      <div className="grid grid-cols-2" data-id="element-1984">
        <div className="border-r border-white/[0.06]" data-id="element-1985">
          {beforeLines.map((line, i) => {
          const changed = afterLines[i] !== line;
          return <div key={i} className={`px-4 py-0.5 whitespace-pre-wrap ${changed ? 'bg-[#2d1215]/60 text-[#f47067]' : 'text-[#8b949e]'}`} data-id="element-1986">
                {line || ' '}
              </div>;
        })}
        </div>
        <div data-id="element-1987">
          {afterLines.map((line, i) => {
          const changed = beforeLines[i] !== line;
          return <div key={i} className={`px-4 py-0.5 whitespace-pre-wrap ${changed ? 'bg-[#12261e]/60 text-[#7ee787]' : 'text-[#8b949e]'}`} data-id="element-1988">
                {line || ' '}
              </div>;
        })}
        </div>
      </div>
    </div>;
}